module.exports = __webpack_public_path__ + "static/media/sel.51fa71c0.svg";